module.exports = __webpack_public_path__ + "img/akubela-page.b96a8029.png";